import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RegistriaSnippetResponse } from '@us-registration/util-models';

@Component({
  selector: 'us-registration-registria-snippet',
  standalone: true,
  imports: [NgFor, NgIf],
  templateUrl: './registration-registria-snippet.component.html',
  styleUrls: ['./registration-registria-snippet.component.scss'],
})
export class RegistrationRegistriaSnippetComponent {
  @Input() registriaSnippet!: RegistriaSnippetResponse;
}
